import { Pager } from "../../domain/model/common";

// client contract detail
interface ICreateContractByClientRequest {
  companyId?: string;
  projectId?: string;
  customerId?: string;
  uploadFile?: File | null;
}
class CreateContractByClientRequest implements ICreateContractByClientRequest {
  public companyId: string;
  public projectId: string;
  public customerId: string;
  public uploadFile: File;
}

interface IUpdateContractByClientRequest {
  companyId?: string;
  projectId?: string;
  customerId?: string;
  uploadFile?: File | null;
}
class UpdateContractByClientRequest implements IUpdateContractByClientRequest {
  public companyId: string;
  public projectId: string;
  public customerId: string;
  public uploadFile: File;
}

interface IOpenCreateFormContractByClientRequest {
  companyId?: string;
  projectId?: string;
  customerId?: string;
}
class OpenCreateFormContractByClientRequest
  implements IOpenCreateFormContractByClientRequest
{
  public companyId: string;
  public projectId: string;
  public customerId: string;
}

// client contract list
interface IGetAllContractListByClientRequest {
  pager: Pager;
}
class GetAllContractListByClientRequest
  implements IGetAllContractListByClientRequest
{
  public pager: Pager;
}

interface IApproveContractByClientRequest {
  companyId?: string;
  projectId?: string;
  customerId?: string;
  uploadFile?: File | null;
}
class ApproveContractByClientRequest
  implements IApproveContractByClientRequest
{
  public companyId: string;
  public projectId: string;
  public customerId: string;
}

export {
  // client contract detail
  CreateContractByClientRequest,
  UpdateContractByClientRequest,
  OpenCreateFormContractByClientRequest,
  // client contract list
  GetAllContractListByClientRequest,
  ApproveContractByClientRequest,
};



// WEBPACK FOOTER //
// ./src/presentation/request/contract_request.ts